import type { EstimateStatus } from '$lib/stores/estimate/types'
import { EstimateStatus as estimateStatus } from '$lib/stores/estimate/types'

// import { getFilter } from '$lib/stores/estimates_list/helpers'

export enum StatusFilter {
	All = 'all',
	Unsent = 'unsent',
	Sent = 'sent',
	Approved = 'approved',
	Invoiced = 'invoiced',
	Refunded = 'refunded',
	Archived = 'archived'
}

export type EstimatesParams = {
	statuses: EstimateStatus[]
	archived: boolean[]
	query: string
	estimateId: string
	
	clientId: string
	itemId: string

	date_start: Date | null
	date_end: Date | null
}

export type EstimatesFilter = {
	name: string
	data_test_id: string
	slug: StatusFilter
	statuses: EstimateStatus[]
	archived: boolean[]
}

export function getDefaultEstimatesParams() {
	return {
		// statuses: getFilter(StatusFilter.All),
		statuses: [
			estimateStatus.Draft,
			estimateStatus.Sent,
			estimateStatus.Viewed,
			estimateStatus.Invoiced,
			estimateStatus.Approved
		],
		archived: [false],
		query: '',
		clientId: '',
		estimateId: '',
		itemId: ''
	}
}
